import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
// Keep layout/header Bootstrap data-api behavior alive without exposing a global bootstrap object.
void Collapse;
void Dropdown;